var map = {
	"./HelveticaNeueCyr-Black.ttf": 265,
	"./HelveticaNeueCyr-Bold.ttf": 266,
	"./HelveticaNeueCyr-ExtraBold.ttf": 267,
	"./HelveticaNeueCyr-Light.ttf": 268,
	"./HelveticaNeueCyr-Medium.ttf": 269,
	"./HelveticaNeueCyr-Regular.ttf": 270,
	"./HelveticaNeueCyr-Thin.ttf": 271,
	"./HelveticaNeueCyr-UltraLight.ttf": 272
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 264;